import type { IconProps } from '../../types/icon-props';

export const WentWrong = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width="121"
      height="120"
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clip-path="url(#clip0_2017_25961)">
        <path
          d="M91.6645 120H11C5.20094 120 0.5 115.299 0.5 109.5V5.58C0.5 2.49835 2.99835 0 6.08 0H10.7485C16.2301 0 21.5744 1.71529 26.0322 4.90541L44.7539 18.3033C47.0861 19.9724 48.9866 22.1736 50.2978 24.7242C51.609 27.2749 52.2929 30.1015 52.2929 32.9694V48.5419C52.2929 52.5679 53.64 56.4782 56.1198 59.6499L64.0273 69.7642C66.3006 72.6718 67.9906 75.9914 69.0042 79.5402L71.8607 89.54C73.5892 95.5912 77.2623 100.905 82.3125 104.66L93.892 113.27C96.7776 115.416 95.2602 120 91.6645 120Z"
          fill="url(#paint0_linear_2017_25961)"
        />
        <path
          d="M93.8931 113.271L82.3135 104.66C77.2633 100.905 73.5902 95.5917 71.8618 89.5405L69.0053 79.5405C67.9916 75.9916 66.3016 72.6721 64.0284 69.7645L56.1208 59.6501C53.6411 56.4784 52.294 52.5681 52.294 48.5421V32.9696C52.294 30.1017 51.61 27.2751 50.2989 24.7245C48.9877 22.1738 47.0872 19.9726 44.7549 18.3035L26.0333 4.90565C21.5755 1.71533 16.2311 -3.6094e-05 10.7493 5.69611e-10L6.08082 5.69613e-10C3.97447 5.69613e-10 2.14129 1.16753 1.19141 2.89035C2.34398 3.47942 3.45139 4.15294 4.50458 4.90541L23.2262 18.3035C25.5584 19.9726 27.459 22.1738 28.7702 24.7245C30.0813 27.2751 30.7653 30.1017 30.7653 32.9696V48.5421C30.7653 52.5681 32.1124 56.4784 34.5921 59.6501L42.4996 69.7645C44.7729 72.6721 46.4628 75.9916 47.4766 79.5405L50.3331 89.5405C52.0615 95.5917 55.7346 100.905 60.7848 104.66L81.4149 120H91.6655C95.2611 120 96.7785 115.416 93.8931 113.271Z"
          fill="url(#paint1_linear_2017_25961)"
        />
        <path
          d="M0.5 109.5C0.5 115.299 5.20094 120 11 120H91.6645C95.2602 120 96.7776 115.416 93.8922 113.271L82.3125 104.66C77.2623 100.905 73.5892 95.5917 71.8607 89.5405L69.0042 79.5405C68.2936 77.0546 67.2498 74.6764 65.9012 72.4706H0.5V109.5Z"
          fill="url(#paint2_linear_2017_25961)"
        />
        <path
          d="M64.0263 69.7645L56.1188 59.6501C53.6391 56.4784 52.292 52.5681 52.292 48.5421V32.9696C52.2919 30.1017 51.608 27.2751 50.2968 24.7245C48.9857 22.1738 47.0851 19.9726 44.7529 18.3035L33.9108 10.5445L26.0312 4.90564L29.703 11.8899C32.4668 17.147 33.9109 22.9973 33.9108 28.9367C33.9108 32.2541 35.2286 35.4356 37.5743 37.7814L39.3061 39.5132C41.6518 41.8589 42.9696 45.0403 42.9696 48.3576V53.5831C42.9696 60.9751 47.1515 67.7308 53.768 71.0273L68.6661 78.4499C67.6324 75.3086 66.0627 72.3701 64.0263 69.7645Z"
          fill="url(#paint3_linear_2017_25961)"
        />
        <path
          d="M0.5 109.5C0.5 115.299 5.20094 120 11 120H91.6645C95.2602 120 96.7776 115.416 93.8922 113.271L82.3127 104.661C77.2625 100.905 73.5894 95.5918 71.8609 89.5405L69.0045 79.5405C67.9908 75.9917 66.3008 72.6721 64.0275 69.7645L56.12 59.6502C53.6403 56.4784 52.2932 52.5682 52.2932 48.5422V32.9697C52.2932 32.8817 52.2906 32.7939 52.2892 32.7059H0.5V109.5Z"
          fill="url(#paint4_linear_2017_25961)"
        />
        <path
          d="M93.894 113.271L82.3145 104.66C77.2643 100.905 73.5912 95.5917 71.8627 89.5405L69.0063 79.5405C68.1288 76.47 66.7441 73.5678 64.9096 70.9539L16.6602 22.7047V120H91.6663C95.262 120 96.7794 115.416 93.894 113.271Z"
          fill="url(#paint5_linear_2017_25961)"
        />
        <path
          d="M18.2617 120H91.6655C95.2613 120 96.7787 115.416 93.8932 113.271L82.3137 104.66C77.2635 100.905 73.5904 95.5917 71.862 89.5404L69.0055 79.5404C67.9918 75.9915 66.3018 72.672 64.0285 69.7644L56.121 59.6501C55.068 58.3022 54.2121 56.8113 53.5791 55.2223L39.8001 41.4432L18.2617 120Z"
          fill="url(#paint6_linear_2017_25961)"
        />
        <path
          d="M18.3595 76.8628H12.9661C12.6974 76.8628 12.4398 76.7561 12.2498 76.5662C12.0598 76.3762 11.9531 76.1185 11.9531 75.8499V61.916H19.3724V75.8499C19.3724 76.1185 19.2657 76.3762 19.0757 76.5662C18.8858 76.7561 18.6281 76.8628 18.3595 76.8628Z"
          fill="url(#paint7_linear_2017_25961)"
        />
        <path
          d="M18.3595 76.8628H12.9661C12.6974 76.8628 12.4398 76.7561 12.2498 76.5662C12.0598 76.3762 11.9531 76.1185 11.9531 75.8499V61.916H19.3724V75.8499C19.3724 76.1185 19.2657 76.3762 19.0757 76.5662C18.8858 76.7561 18.6281 76.8628 18.3595 76.8628Z"
          fill="url(#paint8_linear_2017_25961)"
        />
        <path
          d="M18.3595 76.8628H12.9661C12.6974 76.8628 12.4398 76.7561 12.2498 76.5662C12.0598 76.3762 11.9531 76.1185 11.9531 75.8499V61.916H19.3724V75.8499C19.3724 76.1185 19.2657 76.3762 19.0757 76.5662C18.8858 76.7561 18.6281 76.8628 18.3595 76.8628Z"
          fill="url(#paint9_linear_2017_25961)"
        />
        <path
          d="M26.2172 64.8598L21.0591 51.5365H23.1694C23.7812 51.5365 24.2021 50.9222 23.9814 50.3516L19.0447 37.6H21.1551C21.7668 37.6 22.1878 36.9857 21.9671 36.4151L16.6591 22.7045C16.3071 21.7951 15.02 21.7951 14.668 22.7045L9.36 36.4151C9.13906 36.9857 9.56 37.6 10.172 37.6H12.2824L7.34565 50.3516C7.12471 50.9222 7.54565 51.5365 8.15765 51.5365H10.268L5.11035 64.8598C4.88941 65.4304 5.31035 66.0448 5.92235 66.0448H25.4052C26.0169 66.0448 26.4379 65.4304 26.2172 64.8598Z"
          fill="url(#paint10_linear_2017_25961)"
        />
        <path
          d="M23.9803 50.3515L19.0436 37.6H12.2814L7.34473 50.3515C7.12379 50.9221 7.54473 51.5364 8.15673 51.5364H23.1683C23.7803 51.5364 24.2012 50.9221 23.9803 50.3515Z"
          fill="url(#paint11_linear_2017_25961)"
        />
        <path
          d="M5.92225 66.0447H25.4051C26.0168 66.0447 26.4378 65.4304 26.2171 64.8598L21.059 51.5365H10.2684L5.11025 64.8598C4.88954 65.4304 5.31048 66.0447 5.92225 66.0447Z"
          fill="url(#paint12_linear_2017_25961)"
        />
        <path
          d="M5.92225 66.0447H25.4051C26.0168 66.0447 26.4378 65.4304 26.2171 64.8598L21.059 51.5365H10.2684L5.11025 64.8598C4.88954 65.4304 5.31048 66.0447 5.92225 66.0447Z"
          fill="url(#paint13_linear_2017_25961)"
        />
        <path
          d="M30.4443 81.3312L26.5052 80.2757C26.309 80.2232 26.1417 80.0948 26.0402 79.919C25.9386 79.7431 25.911 79.534 25.9636 79.3378L28.6904 69.1611L34.109 70.6131L31.3821 80.7898C31.3295 80.986 31.2012 81.1532 31.0253 81.2547C30.8494 81.3563 30.6404 81.3838 30.4443 81.3312Z"
          fill="url(#paint14_linear_2017_25961)"
        />
        <path
          d="M30.4443 81.3312L26.5052 80.2757C26.309 80.2232 26.1417 80.0948 26.0402 79.919C25.9386 79.7431 25.911 79.534 25.9636 79.3378L28.6904 69.1611L34.109 70.6131L31.3821 80.7898C31.3295 80.986 31.2012 81.1532 31.0253 81.2547C30.8494 81.3563 30.6404 81.3838 30.4443 81.3312Z"
          fill="url(#paint15_linear_2017_25961)"
        />
        <path
          d="M30.4443 81.3312L26.5052 80.2757C26.309 80.2232 26.1417 80.0948 26.0402 79.919C25.9386 79.7431 25.911 79.534 25.9636 79.3378L28.6904 69.1611L34.109 70.6131L31.3821 80.7898C31.3295 80.986 31.2012 81.1532 31.0253 81.2547C30.8494 81.3563 30.6404 81.3838 30.4443 81.3312Z"
          fill="url(#paint16_linear_2017_25961)"
        />
        <path
          d="M38.5306 74.1022L37.3708 63.3622L38.9122 63.7751C39.359 63.8949 39.7868 63.5285 39.7371 63.0685L38.627 52.7892L40.1684 53.2022C40.6153 53.3219 41.043 52.9556 40.9934 52.4956L39.7997 41.4431C39.7204 40.7099 38.7807 40.4582 38.3456 41.0535L31.7859 50.0283C31.5129 50.4017 31.7002 50.933 32.147 51.0525L33.6884 51.4655L27.5875 59.8125C27.3146 60.1859 27.5019 60.7172 27.9487 60.8367L29.4901 61.2497L23.1155 69.9709C22.8426 70.3443 23.0299 70.8756 23.4767 70.9951L37.7061 74.8078C38.1524 74.9285 38.5802 74.5622 38.5306 74.1022Z"
          fill="url(#paint17_linear_2017_25961)"
        />
        <path
          d="M39.738 63.0684L38.6279 52.7891L33.6891 51.4658L27.5882 59.8129C27.3152 60.1863 27.5025 60.7176 27.9493 60.8373L29.4907 61.2503L37.3719 63.3621L38.9133 63.775C39.3602 63.8948 39.7877 63.5284 39.738 63.0684Z"
          fill="url(#paint18_linear_2017_25961)"
        />
        <path
          d="M23.4767 70.996L37.7061 74.8087C38.1529 74.9285 38.5807 74.5621 38.531 74.1021L37.3713 63.3621L29.4901 61.2504L23.1155 69.9715C22.8426 70.345 23.0299 70.8763 23.4767 70.996Z"
          fill="url(#paint19_linear_2017_25961)"
        />
        <path
          d="M23.4767 70.996L37.7061 74.8087C38.1529 74.9285 38.5807 74.5621 38.531 74.1021L37.3713 63.3621L29.4901 61.2504L23.1155 69.9715C22.8426 70.345 23.0299 70.8763 23.4767 70.996Z"
          fill="url(#paint20_linear_2017_25961)"
        />
        <path
          d="M74.6176 116.191V113.004C74.6176 109.262 73.4809 105.613 71.3666 102.57L62.4871 89.7896C60.2428 86.5595 56.6235 84.643 52.7671 84.643H42.4466C39.7784 84.643 37.1868 83.7235 35.0847 82.0306L28.3814 76.6324C26.4544 75.0807 24.2544 73.927 21.9024 73.235L15.2751 71.2851C11.2647 70.1051 7.74306 67.5976 5.25435 64.1501L0.5 57.564V109.5C0.5 115.299 5.20094 120 11 120H70.9195C72.9619 120 74.6176 118.295 74.6176 116.191Z"
          fill="url(#paint21_linear_2017_25961)"
        />
        <path
          d="M71.3666 102.57L62.4871 89.7898C60.2428 86.5597 56.6235 84.6433 52.7671 84.6433H42.4466C39.7784 84.6433 37.1868 83.7237 35.0847 82.0308L28.3814 76.6327C26.4544 75.0809 24.2544 73.9273 21.9024 73.2353L15.2751 71.2854C11.2647 70.1054 7.74306 67.5978 5.25435 64.1503L0.5 57.564V76.4061C2.07388 77.4595 3.79929 78.2764 5.62823 78.8146L12.2555 80.7644C14.6075 81.4564 16.8075 82.6101 18.7346 84.1618L25.4379 89.56C27.54 91.2527 30.1315 92.1724 32.7998 92.1724H43.1202C46.9765 92.1724 50.596 94.0889 52.8402 97.319L61.7198 110.099C63.7334 112.998 64.8581 116.445 64.9607 120H70.9198C72.9621 120 74.6179 118.294 74.6179 116.191V113.003C74.6176 109.262 73.4809 105.613 71.3666 102.57Z"
          fill="url(#paint22_linear_2017_25961)"
        />
        <path
          d="M0.5 109.5C0.5 115.299 5.20094 120 11 120H70.9195C72.9619 120 74.6176 118.295 74.6176 116.191V113.004C74.6176 109.262 73.4809 105.613 71.3666 102.57L66.3113 95.2941H0.5V109.5Z"
          fill="url(#paint23_linear_2017_25961)"
        />
        <path
          d="M39.0969 102.606C38.1438 102.606 37.2275 102.761 36.3692 103.045C36.4059 102.767 36.4247 102.488 36.4252 102.208C36.4252 98.6605 33.5494 95.7847 30.0019 95.7847C28.4589 95.7829 26.9674 96.339 25.8021 97.3504C24.4565 94.2871 21.3976 92.1469 17.8374 92.1469C13.1812 92.1469 9.37977 95.8061 9.15129 100.406C4.27812 100.99 0.5 105.135 0.5 110.166C0.5 115.597 4.90282 120 10.3339 120H39.0969C43.9002 120 47.7941 116.106 47.7941 111.303C47.7941 106.5 43.9002 102.606 39.0969 102.606Z"
          fill="url(#paint24_linear_2017_25961)"
        />
        <path
          d="M0.50001 110.166C0.50001 115.597 4.90283 120 10.3339 120H39.097C43.9002 120 47.7941 116.106 47.7941 111.303C47.7971 109.292 47.1 107.342 45.8226 105.789H1.52589C0.849022 107.149 0.497802 108.647 0.50001 110.166Z"
          fill="url(#paint25_linear_2017_25961)"
        />
        <path
          d="M39.0973 102.606C38.1441 102.606 37.2279 102.761 36.3695 103.045C36.4063 102.767 36.425 102.488 36.4255 102.208C36.4255 98.6604 33.5498 95.7847 30.0022 95.7847C29.5942 95.7847 29.1952 95.8233 28.8086 95.896V120H39.0973C43.9006 120 47.7945 116.106 47.7945 111.303C47.7945 106.499 43.9006 102.606 39.0973 102.606Z"
          fill="url(#paint26_linear_2017_25961)"
        />
        <path
          d="M36.4249 102.208C36.4251 102.487 36.4072 102.766 36.3715 103.042C33.7602 103.902 31.6955 105.966 30.836 108.578C30.5631 108.613 30.2847 108.631 30.0014 108.631C26.4544 108.631 23.5781 105.755 23.5781 102.208C23.5781 98.6609 26.4544 95.7847 30.0014 95.7847C33.5485 95.7844 36.4249 98.6607 36.4249 102.208Z"
          fill="url(#paint27_linear_2017_25961)"
        />
        <path
          d="M23.579 102.208C23.5769 103.578 24.0153 104.914 24.8296 106.016C23.2449 108.155 20.7039 109.54 17.8378 109.54C13.0345 109.54 9.14062 105.647 9.14062 100.843C9.14062 96.04 13.0345 92.1461 17.8378 92.1461C21.3973 92.1461 24.4578 94.2847 25.8027 97.3473C24.4409 98.5254 23.579 100.266 23.579 102.208Z"
          fill="url(#paint28_linear_2017_25961)"
        />
        <path
          d="M23.5794 102.208C23.5774 103.578 24.0158 104.914 24.83 106.016C23.6829 107.565 22.0345 108.717 20.1243 109.236C19.6559 104.24 15.4519 100.332 10.3347 100.332C9.93446 100.332 9.54011 100.356 9.15234 100.403C9.38199 95.804 13.1825 92.1466 17.838 92.1466C21.3975 92.1466 24.458 94.2852 25.8029 97.3478C24.4413 98.5254 23.5794 100.266 23.5794 102.208Z"
          fill="url(#paint29_linear_2017_25961)"
        />
        <path
          d="M78.0163 98.0965C79.9324 98.0965 81.4857 96.9574 81.4857 95.5523C81.4857 94.1471 79.9324 93.0081 78.0163 93.0081C76.1002 93.0081 74.5469 94.1471 74.5469 95.5523C74.5469 96.9574 76.1002 98.0965 78.0163 98.0965Z"
          fill="url(#paint30_linear_2017_25961)"
        />
        <path
          d="M116.805 98.0965C118.721 98.0965 120.275 96.9574 120.275 95.5523C120.275 94.1471 118.721 93.0081 116.805 93.0081C114.889 93.0081 113.336 94.1471 113.336 95.5523C113.336 96.9574 114.889 98.0965 116.805 98.0965Z"
          fill="url(#paint31_linear_2017_25961)"
        />
        <path
          d="M86.5572 120H80.0972C79.6291 120 79.1801 119.814 78.849 119.483C78.518 119.152 78.332 118.703 78.332 118.235V112.639H88.3224V118.235C88.3224 118.703 88.1364 119.152 87.8054 119.483C87.4743 119.814 87.0254 120 86.5572 120Z"
          fill="url(#paint32_linear_2017_25961)"
        />
        <path
          d="M86.5572 120H80.0972C79.6291 120 79.1801 119.814 78.849 119.483C78.518 119.152 78.332 118.703 78.332 118.235V112.639H88.3224V118.235C88.3224 118.703 88.1364 119.152 87.8054 119.483C87.4743 119.814 87.0254 120 86.5572 120Z"
          fill="url(#paint33_linear_2017_25961)"
        />
        <path
          d="M114.725 120H108.265C108.033 120 107.804 119.954 107.59 119.866C107.376 119.777 107.181 119.647 107.017 119.483C106.853 119.319 106.723 119.124 106.634 118.91C106.546 118.696 106.5 118.467 106.5 118.235V112.639H116.49V118.235C116.49 118.703 116.304 119.152 115.973 119.483C115.642 119.814 115.193 120 114.725 120Z"
          fill="url(#paint34_linear_2017_25961)"
        />
        <path
          d="M114.725 120H108.265C108.033 120 107.804 119.954 107.59 119.866C107.376 119.777 107.181 119.647 107.017 119.483C106.853 119.319 106.723 119.124 106.634 118.91C106.546 118.696 106.5 118.467 106.5 118.235V112.639H116.49V118.235C116.49 118.703 116.304 119.152 115.973 119.483C115.642 119.814 115.193 120 114.725 120Z"
          fill="url(#paint35_linear_2017_25961)"
        />
        <path
          d="M120.248 103.4C120.248 102.523 119.955 101.672 119.417 100.981L116.013 96.6122C115.833 96.3814 115.695 96.1211 115.604 95.8428L113.065 88.0214C112.74 87.0203 112.145 86.1285 111.345 85.4443C110.545 84.7601 109.572 84.3101 108.532 84.144C101.166 82.9668 93.6596 82.9668 86.2933 84.144C85.2539 84.31 84.2807 84.76 83.4809 85.4442C82.681 86.1284 82.0858 87.0203 81.7608 88.0214L79.2213 95.8428C79.1309 96.121 78.9928 96.3814 78.8131 96.6122L75.4091 100.981C74.8704 101.672 74.578 102.523 74.578 103.4C74.578 103.4 73.6015 110.686 75.4794 113.54C77.3573 116.394 97.4131 116.545 97.4131 116.545C97.4131 116.545 117.469 116.395 119.347 113.54C121.224 110.686 120.248 103.4 120.248 103.4Z"
          fill="url(#paint36_linear_2017_25961)"
        />
        <path
          d="M75.4091 100.981C74.8704 101.672 74.578 102.523 74.578 103.399C74.578 103.399 73.6015 110.686 75.4794 113.54C77.3573 116.394 97.4131 116.545 97.4131 116.545C97.4131 116.545 117.469 116.395 119.347 113.54C121.225 110.686 120.248 103.399 120.248 103.399C120.248 102.523 119.956 101.672 119.417 100.981L118.96 100.395H75.8658L75.4091 100.981Z"
          fill="url(#paint37_linear_2017_25961)"
        />
        <path
          d="M119.414 100.981L116.01 96.6123C115.831 96.3815 115.693 96.1211 115.602 95.8429L113.063 88.0214C112.738 87.0204 112.142 86.1285 111.343 85.4443C110.543 84.7601 109.57 84.3101 108.53 84.144C103.924 83.408 99.2551 83.1312 94.5938 83.3177V116.487C96.3072 116.537 97.4105 116.545 97.4105 116.545C97.4105 116.545 117.466 116.395 119.344 113.54C121.222 110.686 120.246 103.4 120.246 103.4C120.246 102.523 119.953 101.672 119.414 100.981Z"
          fill="url(#paint38_linear_2017_25961)"
        />
        <path
          d="M74.7617 102.21C81.2547 104.243 89.0396 105.428 97.4116 105.428C105.784 105.428 113.569 104.242 120.061 102.21C119.921 101.765 119.702 101.349 119.416 100.981L116.012 96.6122C115.832 96.3814 115.694 96.1211 115.603 95.8428L113.064 88.0214C112.739 87.0203 112.144 86.1285 111.344 85.4443C110.544 84.7601 109.571 84.3101 108.531 84.144C101.165 82.9668 93.6586 82.9668 86.2923 84.144C85.253 84.31 84.2797 84.76 83.4799 85.4442C82.6801 86.1284 82.0848 87.0203 81.7598 88.0214L79.2203 95.8428C79.1299 96.121 78.9918 96.3814 78.8121 96.6122L75.4081 100.981C75.1213 101.349 74.9024 101.765 74.7617 102.21Z"
          fill="url(#paint39_linear_2017_25961)"
        />
        <path
          d="M97.4108 99.2305C102.963 99.2305 108.025 98.239 111.849 96.6105C112.66 96.2654 113.077 95.3632 112.805 94.5251L110.92 88.7174C110.724 88.1102 110.364 87.5693 109.88 87.1547C109.395 86.7402 108.805 86.4683 108.175 86.3694C104.615 85.8014 101.016 85.5157 97.4108 85.5148C93.8059 85.5157 90.2067 85.8014 86.6468 86.3694C86.0169 86.4683 85.4267 86.7402 84.9421 87.1547C84.4575 87.5692 84.0975 88.1101 83.9021 88.7171L82.0165 94.5251C81.7445 95.3632 82.1621 96.2651 82.973 96.6105C86.7962 98.239 91.8581 99.2305 97.4108 99.2305Z"
          fill="url(#paint40_linear_2017_25961)"
        />
        <path
          d="M97.4098 85.5148C93.8049 85.5157 90.2057 85.8014 86.6458 86.3694C86.0159 86.4683 85.4257 86.7402 84.9411 87.1547C84.4565 87.5692 84.0965 88.1101 83.9011 88.7171L82.6094 92.6955H112.21L110.919 88.7174C110.723 88.1102 110.363 87.5693 109.879 87.1547C109.394 86.7402 108.804 86.4683 108.174 86.3694C104.614 85.8014 101.015 85.5157 97.4098 85.5148Z"
          fill="url(#paint41_linear_2017_25961)"
        />
        <path
          d="M98.5377 85.5249C98.1621 85.5183 97.7865 85.515 97.4108 85.5148C93.8059 85.5157 90.2067 85.8014 86.6468 86.3694C86.0169 86.4683 85.4267 86.7402 84.9421 87.1547C84.4575 87.5692 84.0975 88.1101 83.9021 88.7171L82.0165 94.5251C81.7445 95.3632 82.1621 96.2651 82.9729 96.6105C86.7965 98.239 91.8586 99.2305 97.4111 99.2305C97.7889 99.2305 98.1645 99.2256 98.5377 99.2164V85.5249Z"
          fill="url(#paint42_linear_2017_25961)"
        />
        <path
          d="M117.605 105.477C117.605 106.801 117.067 108.001 116.199 108.869C115.331 109.737 114.131 110.275 112.806 110.275H109.06C108.417 110.275 107.967 109.644 108.171 109.034C109.024 106.486 110.754 104.322 113.052 102.929C115.02 101.737 117.583 103.129 117.604 105.429L117.605 105.477Z"
          fill="url(#paint43_linear_2017_25961)"
        />
        <path
          d="M108.171 109.034C107.967 109.644 108.417 110.275 109.06 110.275H112.806C114.13 110.275 115.331 109.737 116.199 108.869C117.067 108.001 117.604 106.801 117.604 105.476L117.604 105.429C117.602 105.201 117.574 104.974 117.52 104.753H110.77C109.596 105.968 108.708 107.431 108.171 109.034Z"
          fill="url(#paint44_linear_2017_25961)"
        />
        <path
          d="M114.355 107.504C115.534 107.504 116.491 106.547 116.491 105.368C116.491 104.188 115.534 103.232 114.355 103.232C113.175 103.232 112.219 104.188 112.219 105.368C112.219 106.547 113.175 107.504 114.355 107.504Z"
          fill="url(#paint45_linear_2017_25961)"
        />
        <path
          d="M111.019 108.717C111.761 108.717 112.362 108.116 112.362 107.374C112.362 106.632 111.761 106.031 111.019 106.031C110.277 106.031 109.676 106.632 109.676 107.374C109.676 108.116 110.277 108.717 111.019 108.717Z"
          fill="url(#paint46_linear_2017_25961)"
        />
        <path
          d="M77.2188 105.477C77.2188 106.801 77.7566 108.001 78.6246 108.869C79.4926 109.737 80.6926 110.275 82.0171 110.275H85.7637C86.4063 110.275 86.8564 109.644 86.6529 109.034C85.7994 106.486 84.0697 104.322 81.7715 102.929C79.8035 101.737 77.2409 103.129 77.2192 105.429C77.2188 105.445 77.2188 105.461 77.2188 105.477Z"
          fill="url(#paint47_linear_2017_25961)"
        />
        <path
          d="M86.6526 109.034C86.8564 109.644 86.406 110.275 85.7637 110.275H82.0171C80.6929 110.275 79.4926 109.737 78.6246 108.869C77.7566 108.001 77.2188 106.801 77.2188 105.476L77.219 105.429C77.2212 105.201 77.2496 104.974 77.3037 104.753H84.0529C85.2275 105.968 86.1157 107.431 86.6526 109.034Z"
          fill="url(#paint48_linear_2017_25961)"
        />
        <path
          d="M80.468 107.504C81.6477 107.504 82.604 106.547 82.604 105.368C82.604 104.188 81.6477 103.232 80.468 103.232C79.2884 103.232 78.332 104.188 78.332 105.368C78.332 106.547 79.2884 107.504 80.468 107.504Z"
          fill="url(#paint49_linear_2017_25961)"
        />
        <path
          d="M83.804 108.717C84.5457 108.717 85.1471 108.116 85.1471 107.374C85.1471 106.632 84.5457 106.031 83.804 106.031C83.0622 106.031 82.4609 106.632 82.4609 107.374C82.4609 108.116 83.0622 108.717 83.804 108.717Z"
          fill="url(#paint50_linear_2017_25961)"
        />
        <path
          d="M95.7116 61.4969L78.2299 67.2084C77.356 67.494 76.4201 67.5319 75.526 67.318C74.6318 67.1041 73.8144 66.6468 73.1643 65.9967L59.3287 52.1612C58.5445 51.3769 58.0447 50.3532 57.9085 49.2525L57.5483 46.3414C57.3388 44.6475 57.491 42.9284 57.9947 41.2975C58.4984 39.6667 59.3422 38.1612 60.4704 36.8805L66.7139 29.7936C68.6092 27.6423 72.0756 28.0685 73.3925 30.6155L76.3575 36.3468C76.9552 37.5016 77.801 38.5098 78.8344 39.2992C79.8677 40.0885 81.0628 40.6394 82.3342 40.9125L87.0977 41.9357C87.8528 42.0982 88.5682 42.4088 89.2024 42.8497C89.8366 43.2906 90.377 43.853 90.7923 44.5042L97.8396 55.5515C99.2433 57.7522 98.1932 60.6859 95.7116 61.4969Z"
          fill="url(#paint51_linear_2017_25961)"
        />
        <path
          d="M95.7115 61.4969L78.2298 67.2084C77.3559 67.4939 76.42 67.5318 75.5259 67.3179C74.6317 67.104 73.8143 66.6467 73.1642 65.9967L66.5159 59.3484C67.0095 58.2912 67.0824 57.0859 66.7199 55.9769C66.4339 55.102 66.4169 54.1614 66.6711 53.2768C66.9254 52.3921 67.4392 51.6041 68.146 51.0145L72.2498 47.5929C73.3536 48.7707 74.8697 49.4767 76.4816 49.5632L82.0143 49.8604C82.9194 49.9094 83.8244 49.7614 84.6667 49.4266C85.5091 49.0918 86.2688 48.5783 86.8933 47.9214L90.5145 44.1122C90.6132 44.2384 90.7058 44.3693 90.7919 44.5044L97.8392 55.5517C99.2432 57.7522 98.1931 60.6858 95.7115 61.4969Z"
          fill="url(#paint52_linear_2017_25961)"
        />
        <path
          d="M66.7214 55.984C66.4341 55.1083 66.4162 54.1665 66.6701 53.2805C66.924 52.3945 67.4381 51.6052 68.1457 51.0146L68.4259 50.781L66.8047 49.9582C66.3143 49.7091 65.7797 49.5591 65.2313 49.5167C64.6829 49.4743 64.1316 49.5404 63.6087 49.7111L61.0925 50.533C59.9214 50.9156 59.5664 52.3991 60.4377 53.2702L66.5132 59.3457C66.9854 58.2876 67.0847 57.0887 66.7214 55.984Z"
          fill="url(#paint53_linear_2017_25961)"
        />
        <path
          d="M87.0972 41.9358L82.3336 40.9125C81.0623 40.6394 79.8672 40.0883 78.834 39.2988C77.8008 38.5093 76.9551 37.501 76.3576 36.3461L73.3927 30.6153C72.9327 29.7264 72.2106 29.0967 71.3854 28.7438L69.2334 37.0958C68.9354 38.2523 68.9741 39.4699 69.3449 40.6052L70.863 45.252C71.2556 46.4535 72.0023 47.5081 73.0051 48.2775C74.0079 49.0469 75.22 49.495 76.4821 49.5631L82.0148 49.8612C82.9199 49.9099 83.8248 49.7617 84.667 49.4268C85.5093 49.0919 86.2689 48.5783 86.8934 47.9214L90.5162 44.1101C89.6726 43.0004 88.4599 42.2292 87.0972 41.9358Z"
          fill="url(#paint54_linear_2017_25961)"
        />
        <path
          d="M87.0972 41.9358L82.3336 40.9125C81.0623 40.6394 79.8672 40.0883 78.834 39.2988C77.8008 38.5093 76.9551 37.501 76.3576 36.3461L73.3927 30.6153C72.9327 29.7264 72.2106 29.0967 71.3854 28.7438L69.2334 37.0958C68.9354 38.2523 68.9741 39.4699 69.3449 40.6052L70.863 45.252C71.2556 46.4535 72.0023 47.5081 73.0051 48.2775C74.0079 49.0469 75.22 49.495 76.4821 49.5631L82.0148 49.8612C82.9199 49.9099 83.8248 49.7617 84.667 49.4268C85.5093 49.0919 86.2689 48.5783 86.8934 47.9214L90.5162 44.1101C89.6726 43.0004 88.4599 42.2292 87.0972 41.9358Z"
          fill="url(#paint55_linear_2017_25961)"
        />
        <path
          d="M97.84 55.5513L90.7934 44.5043C90.7064 44.3694 90.6138 44.2382 90.5158 44.1111L86.8937 47.9214C86.1287 48.7256 85.1638 49.3121 84.0977 49.6207L84.5198 50.9132C85.0435 52.5161 86.1825 53.8453 87.6861 54.6085C88.4307 54.9863 89.0936 55.5072 89.6369 56.1412C90.1801 56.7752 90.5932 57.5101 90.8525 58.3038L92.2638 62.6238L95.7125 61.497C98.1941 60.6861 99.2438 57.752 97.84 55.5513Z"
          fill="url(#paint56_linear_2017_25961)"
        />
        <path
          d="M59.4105 38.2775C57.8589 40.6621 57.1994 43.518 57.5481 46.3415L57.9083 49.2525C58.0445 50.3532 58.5444 51.3769 59.3286 52.1612L73.1641 65.9968C73.8142 66.6469 74.6316 67.1042 75.5258 67.3181C76.4199 67.532 77.3558 67.4941 78.2297 67.2085L85.8514 64.7184L59.4105 38.2775Z"
          fill="url(#paint57_linear_2017_25961)"
        />
        <path
          d="M57.4747 16.7059C59.424 16.7059 61.0041 15.1257 61.0041 13.1765C61.0041 11.2273 59.424 9.64709 57.4747 9.64709C55.5255 9.64709 53.9453 11.2273 53.9453 13.1765C53.9453 15.1257 55.5255 16.7059 57.4747 16.7059Z"
          fill="url(#paint58_linear_2017_25961)"
        />
        <path
          d="M60.5329 25.7254C61.8756 25.7254 62.9642 24.6369 62.9642 23.2941C62.9642 21.9513 61.8756 20.8628 60.5329 20.8628C59.1901 20.8628 58.1016 21.9513 58.1016 23.2941C58.1016 24.6369 59.1901 25.7254 60.5329 25.7254Z"
          fill="url(#paint59_linear_2017_25961)"
        />
        <path
          d="M44.0641 13.4902C45.4069 13.4902 46.4954 12.4016 46.4954 11.0589C46.4954 9.71609 45.4069 8.62756 44.0641 8.62756C42.7213 8.62756 41.6328 9.71609 41.6328 11.0589C41.6328 12.4016 42.7213 13.4902 44.0641 13.4902Z"
          fill="url(#paint60_linear_2017_25961)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2017_25961"
          x1="21.7085"
          y1="63.9108"
          x2="47.2772"
          y2="74.7344"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2017_25961"
          x1="49.7651"
          y1="58.7656"
          x2="26.0003"
          y2="82.0598"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2017_25961"
          x1="47.9525"
          y1="99.7647"
          x2="47.9525"
          y2="120.248"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2017_25961"
          x1="49.2094"
          y1="40.8988"
          x2="22.5035"
          y2="52.0753"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2017_25961"
          x1="47.8774"
          y1="75.1403"
          x2="37.2892"
          y2="92.0815"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2017_25961"
          x1="38.5903"
          y1="73.5158"
          x2="22.355"
          y2="75.7511"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2017_25961"
          x1="46.2427"
          y1="83.9305"
          x2="32.3603"
          y2="81.3423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2017_25961"
          x1="13.6197"
          y1="69.3897"
          x2="19.8569"
          y2="69.3897"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2017_25961"
          x1="15.6628"
          y1="69.3897"
          x2="15.6628"
          y2="65.1391"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2017_25961"
          x1="15.6628"
          y1="73.852"
          x2="15.6628"
          y2="77.1322"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2017_25961"
          x1="10.724"
          y1="44.0337"
          x2="24.3447"
          y2="44.0337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BBEC6C" />
          <stop offset="1" stop-color="#78A91F" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2017_25961"
          x1="17.2908"
          y1="44.7612"
          x2="23.8132"
          y2="42.3153"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_2017_25961"
          x1="16.9058"
          y1="59.2243"
          x2="24.2434"
          y2="56.1069"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_2017_25961"
          x1="15.6637"
          y1="61.9367"
          x2="15.6637"
          y2="66.9026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_2017_25961"
          x1="28.4399"
          y1="74.9533"
          x2="32.9956"
          y2="76.1723"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_2017_25961"
          x1="29.9321"
          y1="75.3526"
          x2="30.7628"
          y2="72.2479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_2017_25961"
          x1="29.0599"
          y1="78.612"
          x2="28.4188"
          y2="81.008"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_2017_25961"
          x1="31.2789"
          y1="55.8666"
          x2="41.2277"
          y2="58.5286"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BBEC6C" />
          <stop offset="1" stop-color="#78A91F" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_2017_25961"
          x1="35.9354"
          y1="57.6816"
          x2="41.1776"
          y2="57.1698"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_2017_25961"
          x1="32.8259"
          y1="68.1705"
          x2="38.7948"
          y2="67.3276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_2017_25961"
          x1="31.3884"
          y1="69.9089"
          x2="30.4178"
          y2="73.5361"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_2017_25961"
          x1="39.5261"
          y1="76.6731"
          x2="31.9967"
          y2="116.438"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_2017_25961"
          x1="37.5939"
          y1="86.9256"
          x2="32.4174"
          y2="110.926"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_2017_25961"
          x1="37.5588"
          y1="101.647"
          x2="37.5588"
          y2="118.59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_2017_25961"
          x1="12.2085"
          y1="99.0313"
          x2="36.2365"
          y2="123.059"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BBEC6C" />
          <stop offset="1" stop-color="#78A91F" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_2017_25961"
          x1="24.1471"
          y1="112.176"
          x2="24.1471"
          y2="120.808"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_2017_25961"
          x1="40.8578"
          y1="110.118"
          x2="50.5211"
          y2="112.051"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_2017_25961"
          x1="30.6066"
          y1="102.009"
          x2="38.4511"
          y2="99.8489"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_2017_25961"
          x1="21.3536"
          y1="97.8918"
          x2="27.4929"
          y2="92.7381"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_2017_25961"
          x1="14.9989"
          y1="101.881"
          x2="7.53352"
          y2="104.609"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#78A91F" stop-opacity="0" />
          <stop offset="0.147" stop-color="#70A421" stop-opacity="0.147" />
          <stop offset="0.374" stop-color="#5B9927" stop-opacity="0.374" />
          <stop offset="0.652" stop-color="#378531" stop-opacity="0.652" />
          <stop offset="0.968" stop-color="#076B3F" stop-opacity="0.968" />
          <stop offset="1" stop-color="#026841" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_2017_25961"
          x1="76.3972"
          y1="93.9332"
          x2="78.9645"
          y2="96.5005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E1D3CE" />
          <stop offset="1" stop-color="#9E9797" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_2017_25961"
          x1="115.186"
          y1="93.9332"
          x2="117.754"
          y2="96.5005"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#E1D3CE" />
          <stop offset="1" stop-color="#9E9797" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_2017_25961"
          x1="82.4953"
          y1="113.766"
          x2="84.4106"
          y2="118.047"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5A5A5A" />
          <stop offset="1" stop-color="#444444" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_2017_25961"
          x1="82.945"
          y1="122.571"
          x2="83.3205"
          y2="115.586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#433F43" stop-opacity="0" />
          <stop offset="0.317" stop-color="#3B373B" stop-opacity="0.317" />
          <stop offset="0.822" stop-color="#242324" stop-opacity="0.822" />
          <stop offset="1" stop-color="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_2017_25961"
          x1="110.663"
          y1="113.766"
          x2="112.579"
          y2="118.048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5A5A5A" />
          <stop offset="1" stop-color="#444444" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_2017_25961"
          x1="111.113"
          y1="122.571"
          x2="111.489"
          y2="115.586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#433F43" stop-opacity="0" />
          <stop offset="0.317" stop-color="#3B373B" stop-opacity="0.317" />
          <stop offset="0.822" stop-color="#242324" stop-opacity="0.822" />
          <stop offset="1" stop-color="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_2017_25961"
          x1="84.8342"
          y1="84.5471"
          x2="106.38"
          y2="121.318"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#5A5A5A" />
          <stop offset="1" stop-color="#444444" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_2017_25961"
          x1="97.4131"
          y1="107.907"
          x2="97.4131"
          y2="116.131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#433F43" stop-opacity="0" />
          <stop offset="0.317" stop-color="#3B373B" stop-opacity="0.317" />
          <stop offset="0.822" stop-color="#242324" stop-opacity="0.822" />
          <stop offset="1" stop-color="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_2017_25961"
          x1="106.352"
          y1="98.8887"
          x2="116.718"
          y2="95.9593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#433F43" stop-opacity="0" />
          <stop offset="0.317" stop-color="#3B373B" stop-opacity="0.317" />
          <stop offset="0.822" stop-color="#242324" stop-opacity="0.822" />
          <stop offset="1" stop-color="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_2017_25961"
          x1="96.5822"
          y1="100.226"
          x2="101.202"
          y2="111.155"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#433F43" stop-opacity="0" />
          <stop offset="0.317" stop-color="#3B373B" stop-opacity="0.317" />
          <stop offset="0.822" stop-color="#242324" stop-opacity="0.822" />
          <stop offset="1" stop-color="#1A1A1A" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_2017_25961"
          x1="93.6628"
          y1="85.9317"
          x2="100.123"
          y2="100.204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D5DAF3" />
          <stop offset="1" stop-color="#60B7FF" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_2017_25961"
          x1="97.4098"
          y1="88.8647"
          x2="97.4098"
          y2="84.6959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1F3596" stop-opacity="0" />
          <stop offset="0.407" stop-color="#1D3290" stop-opacity="0.407" />
          <stop offset="0.951" stop-color="#192B7F" stop-opacity="0.951" />
          <stop offset="1" stop-color="#192A7D" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_2017_25961"
          x1="90.72"
          y1="91.0529"
          x2="82.4951"
          y2="87.5599"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1F3596" stop-opacity="0" />
          <stop offset="0.407" stop-color="#1D3290" stop-opacity="0.407" />
          <stop offset="0.951" stop-color="#192B7F" stop-opacity="0.951" />
          <stop offset="1" stop-color="#192A7D" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_2017_25961"
          x1="111.42"
          y1="104.793"
          x2="114.204"
          y2="109.26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEF0AE" />
          <stop offset="1" stop-color="#FAC600" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_2017_25961"
          x1="112.863"
          y1="107.342"
          x2="112.863"
          y2="110.537"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="0.203" stop-color="#FDA215" stop-opacity="0.203" />
          <stop offset="0.405" stop-color="#FB961B" stop-opacity="0.405" />
          <stop offset="0.607" stop-color="#F68225" stop-opacity="0.607" />
          <stop offset="0.807" stop-color="#F06633" stop-opacity="0.807" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_2017_25961"
          x1="112.995"
          y1="104.008"
          x2="117.521"
          y2="108.534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="0.203" stop-color="#FDA215" stop-opacity="0.203" />
          <stop offset="0.405" stop-color="#FB961B" stop-opacity="0.405" />
          <stop offset="0.607" stop-color="#F68225" stop-opacity="0.607" />
          <stop offset="0.807" stop-color="#F06633" stop-opacity="0.807" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_2017_25961"
          x1="110.164"
          y1="106.519"
          x2="113.009"
          y2="109.365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="0.203" stop-color="#FDA215" stop-opacity="0.203" />
          <stop offset="0.405" stop-color="#FB961B" stop-opacity="0.405" />
          <stop offset="0.607" stop-color="#F68225" stop-opacity="0.607" />
          <stop offset="0.807" stop-color="#F06633" stop-opacity="0.807" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_2017_25961"
          x1="83.403"
          y1="104.793"
          x2="80.6197"
          y2="109.26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEF0AE" />
          <stop offset="1" stop-color="#FAC600" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_2017_25961"
          x1="81.9606"
          y1="107.342"
          x2="81.9606"
          y2="110.537"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="0.203" stop-color="#FDA215" stop-opacity="0.203" />
          <stop offset="0.405" stop-color="#FB961B" stop-opacity="0.405" />
          <stop offset="0.607" stop-color="#F68225" stop-opacity="0.607" />
          <stop offset="0.807" stop-color="#F06633" stop-opacity="0.807" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_2017_25961"
          x1="81.8276"
          y1="104.008"
          x2="77.3024"
          y2="108.534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="0.203" stop-color="#FDA215" stop-opacity="0.203" />
          <stop offset="0.405" stop-color="#FB961B" stop-opacity="0.405" />
          <stop offset="0.607" stop-color="#F68225" stop-opacity="0.607" />
          <stop offset="0.807" stop-color="#F06633" stop-opacity="0.807" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_2017_25961"
          x1="84.6588"
          y1="106.519"
          x2="81.8134"
          y2="109.365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FEA613" stop-opacity="0" />
          <stop offset="0.203" stop-color="#FDA215" stop-opacity="0.203" />
          <stop offset="0.405" stop-color="#FB961B" stop-opacity="0.405" />
          <stop offset="0.607" stop-color="#F68225" stop-opacity="0.607" />
          <stop offset="0.807" stop-color="#F06633" stop-opacity="0.807" />
          <stop offset="1" stop-color="#E94444" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_2017_25961"
          x1="81.1845"
          y1="37.3605"
          x2="74.7763"
          y2="64.0456"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_2017_25961"
          x1="80.2049"
          y1="52.9416"
          x2="75.9077"
          y2="43.2731"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_2017_25961"
          x1="64.6071"
          y1="54.4283"
          x2="70.3436"
          y2="54.326"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_2017_25961"
          x1="81.1431"
          y1="37.2733"
          x2="67.4611"
          y2="59.0632"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_2017_25961"
          x1="79.4216"
          y1="41.6593"
          x2="63.1863"
          y2="34.8358"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_2017_25961"
          x1="91.0479"
          y1="53.3947"
          x2="80.6574"
          y2="52.827"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_2017_25961"
          x1="69.7488"
          y1="54.3628"
          x2="65.622"
          y2="58.4896"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#C4573A" stop-opacity="0" />
          <stop offset="1" stop-color="#883F2E" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_2017_25961"
          x1="53.0825"
          y1="8.78427"
          x2="59.6154"
          y2="15.3172"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_2017_25961"
          x1="57.5072"
          y1="20.2684"
          x2="62.0074"
          y2="24.7689"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_2017_25961"
          x1="41.0385"
          y1="8.03321"
          x2="45.5389"
          y2="12.5337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F89580" />
          <stop offset="1" stop-color="#C4573A" />
        </linearGradient>
        <clipPath id="clip0_2017_25961">
          <rect width="120" height="120" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

WentWrong.displayName = 'WentWrong';
